import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SiteHeader from './SiteHeader';
import { VERSION_STRING } from '../../version';

interface EditorLayoutProps {
  children: ReactNode;
}

export default function EditorLayout({ children }: EditorLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const displayName = user?.email?.split('@')[0] ?? 'Szerkesztő';
  const initials    = displayName.slice(0, 1).toUpperCase();

  const navItems = [
    {
      path: '/editor/publication',
      label: 'Kiadvány anyagok',
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
      ),
    },
    {
      path: '/editor/profile',
      label: 'Jelszócsere',
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.07 4.93a10 10 0 010 14.14M4.93 4.93a10 10 0 000 14.14"/>
        </svg>
      ),
    },
  ];

  return (
    <div className="app-shell">
      <SiteHeader roleLabel="Szerkesztő" />

      <div className="app-body">
        <aside className="app-sidebar">
          <div style={{ padding: '14px 16px 6px' }}>
            <span className="badge badge-neutral" style={{ fontSize: 11, letterSpacing: '.06em' }}>
              SZERKESZTŐ
            </span>
          </div>

          <nav style={{ padding: '8px 12px 0', display: 'flex', flexDirection: 'column', gap: 2 }}>
            {navItems.map((item) => (
              <button
                key={item.path}
                className={`nav-item ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
                onClick={() => navigate(item.path)}
              >
                {item.icon}
                {item.label}
              </button>
            ))}
          </nav>

          <div style={{ flex: 1 }} />

          <div style={{ padding: '6px 16px 4px', textAlign: 'center' }}>
            <span style={{ fontSize: 10, color: 'var(--muted-foreground)', fontFamily: 'monospace', letterSpacing: '.04em' }}>
              {VERSION_STRING}
            </span>
          </div>

          <div style={{ padding: '10px 16px 14px', borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 32, height: 32, borderRadius: '50%',
              background: 'var(--primary)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: 12, flexShrink: 0,
            }}>{initials}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)' }}>{displayName}</div>
              <div style={{ fontSize: 11, color: 'var(--muted-foreground)' }}>Szerkesztő</div>
            </div>
          </div>
        </aside>

        <main className="app-main">{children}</main>
      </div>
    </div>
  );
}
